/*
*   网关管理组件
*   zxw
*   2024-10-20
*/

import React , { Component,useState,useEffect } from 'react';
import * as ReactDOM from 'react-dom/client';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import { Row, Col, message, Table, Input, 
    Select, Modal, Button, Dropdown, Tag,} from 'antd';
import { DownOutlined, PlusOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import { UjoinParams, AddRequestHeaders, winWidth, Html2pdf,} from '../../incs/FunHelper.js';

import XZTLOGO from '../../images/logo_head.png';
import PAGEHEADERRIGHT from '../../images/page-header-right.png';

import Entity from './VSDevlsEntity.js';
import ProductInfo from '../commons/ProductInfo.js';

const Option = Select.Option;
const { TextArea } = Input;
const MODULENAME = '设备直播';

let root = null;

/**
 * 信息提示框组件
 * @param {*} props 
 * @returns 
 */
const InfoPromptModal = (props) => {
    const [open, setOpen] = useState(false);
    const [description, setDescription] = useState('');

    useEffect(()=>{
        setOpen(props.open);
    }, [props]);

    /**
     * 取消
     */
    const handleCancel = () =>{
        setDescription('');
        setOpen(false);
    }

    /**
     *  处理
     *  @param {*} record 
     *  @param {*} action 
     */
   const handleOK = () =>{
        $.ajax({
            url: `${CNF.api}gateways/${props.record.key}`,
            headers: AddRequestHeaders(),
            type: props.action==='DELETE'?'DELETE':'PUT',
            dataType: 'JSON',
            data:JSON.stringify({
                'action': props.action,
                'description': description
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                    setTimeout(function(){
                        props.isRefresh();
                    }, 1500);
                }else{
                    message.error(data.msg, 1);
                }
                handleCancel();
            }
        })
    }

    return (
        <>
            <Modal
                okType='danger'
                title={<><ExclamationCircleFilled style={{ color: '#FAAD13' }} /> {MODULENAME}</>}
                closeIcon={false}
                open={open}
                onOk={()=>{handleOK()}}
                onCancel={()=>{handleCancel()}}
                okText='确认'
                cancelText='取消'
                okButtonProps={{disabled: description?false:true}}
            >
                <div>
                    <p style={{ marginTop: 0 }}>考虑清楚了？确定要{props.action==='DISABLE'?'禁用':props.action==='ACTIVE'?'激活':'删除'}该{MODULENAME}：{props.record.number}</p>
                    <TextArea
                        placeholder='必填字段，需要备注说明'
                        autoSize={{ minRows: 3, maxRows: 5 }}
                        onChange={(e)=>{setDescription(e.target.value)}}
                        value={description}
                    />
                </div>
            </Modal>
        </>
    );
}

/**
 * 显示信息
 * @param {*} props 
 * @returns 
 */
const Info = (props) => {
    const [propsState, setPropsState] = useState(props);
    const handleCancel = () => {setPropsState(false);};
    const printer = () => { 
        var printContents = document.getElementById('print-info-id').innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
    };
    const download = () => { Html2pdf('print-info-id', props.record.number,'');};

    useEffect(() => {
        setPropsState(props);
    }, [props]);
    return (
        <>
            <Modal 
                width={820}
                style={{ top: 0}}
                // title={props.record.name}
                closable={false}
                open={propsState.isModalOpen}
                keyboard={true}
                maskClosable={true}
                onCancel={handleCancel}
                footer={[
                    <Button key='back' onClick={handleCancel}>取消</Button>,
                    <Button key='printer' type='primary' onClick={printer}>打印</Button>,
                    <Button key='link' type='primary' onClick={download}>下载</Button>,
                ]}
            >
                <div id='print-info-id'>
                    <div className='print-info' style={{ padding: '0 30px' }}>
                        <Row style={{ margin: '10px' }}>
                            <Col span={2}><img src={XZTLOGO} height='45px' alt={'新致腾'} /></Col>
                            {
                                <Col span={22} align='right'><img src={PAGEHEADERRIGHT} height='35px' alt='新致腾' /></Col>
                            }
                        </Row>
                        <table width='100%'>
                                <thead align='center'>
                                    <tr>
                                        <th colSpan='24'><h2>直播设备表</h2></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colSpan='5' style={{ width: 120 }}>编码:</td><td colSpan='8' style={{ width: 220 }}>{props.record.number}</td>
                                        <td colSpan='3' style={{ width: 140 }}>名称:</td><td colSpan='8' style={{ width: 240 }}>{props.record.name}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan='5' style={{ width: 120 }}>序列号:</td><td colSpan='8' style={{ width: 220 }}>{props.record.serial_number}</td>
                                        <td colSpan='3' style={{ width: 140 }}>通道号:</td><td colSpan='8' style={{ width: 240 }}><Tag color='blue'>{props.record.channel_number}</Tag></td>
                                    </tr>
                                    <tr>
                                        <td colSpan='5' style={{ width: 120 }}>直播地址类型:</td><td colSpan='8' style={{ width: 220 }}>{CNF.lsUrlType.filter(item=>{return item.value===props.record.url_type})[0].key}</td>
                                        <td colSpan='3' style={{ width: 140 }}>码流类型:</td><td colSpan='8' style={{ width: 240 }}>{props.record.stream_number>0? '标清辅码流':'高清主码流'}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan='5' style={{ width: 120 }}>品牌:</td><td colSpan='8' style={{ width: 220 }}>{props.record.brand}</td>
                                        <td colSpan='3' style={{ width: 140 }}>产品编码:</td><td colSpan='8' style={{ width: 240 }}>{props.record.product_number}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan='5' style={{ width: 120 }}>设备状态:</td><td colSpan='8' style={{ width: 220 }}>{<Tag color={props.record.device_status>1?'red':'green'}>{
                                                CNF.deviceStatus.filter(item=>{return item.value===props.record.device_status})[0].key
                                            }</Tag>}</td>
                                        <td colSpan='3' style={{ width: 140 }}>平台编码:</td><td colSpan='8' style={{ width: 240 }}>{props.record.platform_number}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan='5' style={{ width: 120 }}>创建者:</td><td colSpan='8' style={{ width: 220 }}>{props.record.create_displayname}</td>
                                        <td colSpan='3' style={{ width: 140 }}>创建时间:</td><td colSpan='8' style={{ width: 240 }}>{props.record.create_time}</td>
                                    </tr>
                                    <tr><td colSpan='5' style={{ width: 120 }}>备注:</td><td colSpan='19' style={{ width: 600 }}>
                                        {props.record.description&&props.record.description.split('\n').map((item)=>{
                                            return <p style={{ margin: 0 }}>{item}</p>;
                                        })}
                                    </td></tr>
                                </tbody>
                            </table>
                    </div>
                </div>
            </Modal>
        </>
    );
};

class Lists extends Component{
    constructor(props){
        super(props);
        this.state = {
            dataLists: this.props.dataLists,
        }
    }

    update = (record) =>{this.props.setIsModalOpen(true, record);}
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.dataLists !== nextProps.dataLists) {
            this.setState({
                dataLists: nextProps.dataLists,
            })
        }
    }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    operation = (action, record) => {
        switch(action){
            case 'update':
                this.update(record);
                break;
            case 'delete':
                this.showInfoPromptModal(record,'DELETE');
                break
            default:
                break;
        }
    }

    /**
     * 显示提示框信息信息
     * @param {*} record 
     */
    showInfoPromptModal = (record, action) =>{
        if(!root){
            root = ReactDOM.createRoot(document.getElementById('info-prompt-modal-id'));
        }
        root.render(
            <InfoPromptModal
                open={true}
                isRefresh={this.props.isRefresh}
                action={action}
                record={record}
            />
        );
    }

    /**
     * 显示网关信息
     * @param {*} record 
     */
    showInfo = (record) =>{
        if(!root){
            root = ReactDOM.createRoot(document.getElementById('show-info-id'));
        }
        root.render(
            <Info
                isModalOpen={true}
                record={record}
            />
        );
    }

    /**
     * 显示产品信息
     * @param {*} record 
     */
    showProductInfo = (record) =>{
        if(!root){
            root = ReactDOM.createRoot(document.getElementById('product-info-id'));
        }
        root.render(
            <ProductInfo
                open={true}
                number={record.product_number}
            />
        );
    }

    render(){
        const columns = [
            {title: '',width: 20,dataIndex: '',key: 'key',fixed: 'left',},
            {title: '编码',key: 'number',
                render: (record) => <Button type='link' 
                    style={{ padding:0, border:0, height:15 }} 
                    onClick={()=>{this.showInfo(record);}}>{record.number}</Button>
            },
            {title: '名称',key: 'name',dataIndex: 'name',},
            {title: '序列号',key: 'serial_number',dataIndex: 'serial_number',},
            {title: '通道号',key: 'channel_number',
                render: (record) => <Tag color='blue'>{record.channel_number}</Tag>
            },
            {title: '直播地址类型',key: 'url_type',
                render: (record) => CNF.lsUrlType.filter(item=>{return item.value===record.url_type})[0].key
            },
            {title: '码流类型',key: 'stream_number', 
                render: (record) => record.stream_number>0? '标清辅码流':'高清主码流'
            },
            {title: '设备状态',key: 'device_status',
                render: (record) => <Tag color={record.device_status>1?'red':'green'}>{
                    CNF.deviceStatus.filter(item=>{return item.value===record.device_status})[0].key
                }</Tag>
            },
            {title: '品牌',key: 'brand', dataIndex: 'brand',},
            {title: '产品编码',key: 'product_number', 
                render: (record) => <Button type='link' 
                    style={{ padding:0, border:0, height:15 }} 
                    onClick={()=>{this.showProductInfo(record);}}>{record.product_number?record.product_number:'-'}</Button>
            },
            {title: '平台编码',key: 'platform_number', dataIndex: 'platform_number',},
            {title: '创建时间', dataIndex: 'create_time', key: 'create_time',width: 120,hidden: winWidth>1440?false:true,},
            {title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: 80,hidden: winWidth>1440?false:true,},
            {title: '', key: 'operation', fixed: 'right', width: 80,
                render: (record) => {
                    let items = [];
                    if(this.props.btnLists.indexOf('btn_teii_vs_devls_update')>0){
                        items.push({key: '1', label: (<Button style={{ height: 20 }} type='link' onClick={()=>{this.operation('update', record)}}>修改</Button>)})
                    }
                    if(this.props.btnLists.indexOf('btn_teii_vs_devls_delete')>=0){
                        items.push({key: '4', label: (<Button style={{ height: 20 }} type='link' onClick={()=>{this.operation('delete', record)}}>删除</Button>)})
                    }
                    return (
                        <Dropdown menu={{ items, }}>
                            <Button type='link' style={{ padding:0, height: 10,margin:0 }}>
                                    操作
                                    <DownOutlined />
                            </Button>
                        </Dropdown>
                    );
                }
            }
        ];
        return(
            <div>
                <Table 
                    columns={columns} 
                    className='content-table-row'
                    size='middle'
                    dataSource={this.state.dataLists} 
                    // scroll={{ x: winWidth}} 
                    pagination={{
                        showSizeChanger: false,
                        // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                        showQuickJumper: false,
                        showTotal: () => `共${this.props.pageCount}条`,
                        pageSize: winWidth>1440?CNF.pageSize:CNF.pageSize-2,
                        current: this.props.currentIndex,
                        total: this.props.pageCount,
                        onShowSizeChange: (current,pageSize) => this.props.changePageSize(pageSize,current),
                        onChange: (current) => this.props.changeIndex(current),
                    }}
                />
            </div>
        );
    }
}

class CPT extends Component{
    constructor(props){
        super(props);
        this.state = {
            record: null,
            isModalOpen: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            number: '',
            name: '',
            serialNumber: '',
            deviceStatus: '',
        }
    }

    isRefresh = () =>{this.setState({isRefresh: this.state.isRefresh===1 ? 0:1});}
    search = () => {this.setState({currentIndex: 1});this.isRefresh();}
    changeNumber = (e) =>{this.setState({number: e.target.value});this.search();}
    changeName = (e) =>{this.setState({name: e.target.value});this.search();}
    changeSerialNumber = (e) =>{this.setState({serialNumber: e.target.value});this.search();}
    changeDeviceStatus = (value) =>{ this.setState({ deviceStatus: value});this.search();}
    changeIndex = (index) =>{this.setState({currentIndex: index});this.isRefresh();}
    setIsModalOpen = (value, record) =>{this.setState({isModalOpen: value, record: record});}
    create = () =>{this.setIsModalOpen(true, null);}

    /**
     * 获取列表
     */
    getLists(){
        const _this = this;
        const params = {
            'number': this.state.number,
            'name': this.state.name,
            'serial_number': this.state.serialNumber,
            'device_status': this.state.deviceStatus,
            'page_size': winWidth>1440?CNF.pageSize:CNF.pageSize-2,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}vs/devlss${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    if(data.dat.length > 0){
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    }else{
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                }else{
                    message.error(data.msg, 1.5);
                }
            }
        })
    }

    componentDidUpdate(){
        if(this.state.init !== this.state.isRefresh){
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount(){
        this.getLists();
    }

    render(){
        return(
            <>
                <div>
                    <Row style={{ height: 60, paddingTop:10, paddingLeft:20}}>
                        <Col span={winWidth>1440?2:3}>
                            <Input
                                onChange={this.changeNumber}
                                onPressEnter={this.search}
                                placeholder='设备编码...'
                                value={this.state.number}
                            />
                        </Col>
                        <Col span={winWidth>1440?2:3} style={{ marginLeft: 5 }}>
                            <Input
                                onChange={this.changeName}
                                onPressEnter={this.search}
                                placeholder='设备名称...'
                                value={this.state.name}
                            />
                        </Col>
                        <Col span={winWidth>1440?2:3} style={{ marginLeft: 5 }}>
                            <Input
                                onChange={this.changeSerialNumber}
                                onPressEnter={this.search}
                                placeholder='序列号...'
                                value={this.state.serialNumber}
                            />
                        </Col>
                        <Col span={winWidth>1440?2:3} style={{ marginLeft: 5 }}>
                            <Select 
                                onChange={this.changeDeviceStatus}
                                value={this.state.deviceStatus}
                                style={{ width: '100%' }} 
                            >
                                <Option value=''>设备状态</Option>
                                {
                                    CNF.deviceStatus && CNF.deviceStatus.map((item) => {
                                        return <Option key={item.value} value={item.value}>{item.key}</Option>
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={2} style={{ lineHeight: 2.2,marginLeft: 10 }}>
                        {
                            this.props.btnLists.indexOf('btn_teii_vs_devls_create') >=0 ? (
                                <>
                                    <Button 
                                        title={MODULENAME}
                                        type='link'
                                        icon={<PlusOutlined/>}
                                        onClick={() =>{
                                            this.create();
                                        }}>
                                    </Button>
                                </>):''
                            }
                        </Col>
                        <Entity 
                            policy={this.props.policy}
                            isModalOpen={this.state.isModalOpen} 
                            record={this.state.record}
                            setIsModalOpen={this.setIsModalOpen} 
                            datacenterDDList={this.state.datacenterDDList}
                            isRefresh={this.isRefresh}
                        />
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Lists
                                preGroup={this.props.preGroup}
                                btnLists={this.props.btnLists}
                                dataLists={this.state.dataLists} 
                                currentIndex={this.state.currentIndex}
                                pageCount={this.state.pageCount} 
                                changeIndex={this.changeIndex} 
                                setIsModalOpen={this.setIsModalOpen}
                                isRefresh={this.isRefresh}
                            />
                        </Col>
                    </Row>
                </div>
                <div id='info-prompt-modal-id'></div>
                <div id='show-info-id'></div>
                <div id='product-info-id'></div>
            </>
        );
    }
}

export default CPT